import React from "react";
import EmptyUserIcon from "../../../assets/icons/user-icon-empty.svg";
import AvenIcon from "../../../assets/icons/aven-icon.svg";
import StarIcon from "../../../assets/icons/star-icon.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";

const Testimonial = () => {
  const [, setSwiperRef] = React.useState();

  const userList = [
    {
      id: 1,
      name: "",
      description: "",
    },
    {
      id: 2,
      name: "",
      description: "",
    },
    {
      id: 3,
      name: "",
      description: "",
    },
    {
      id: 4,
      name: "Cristofer Vaccaro",
      description: "CEO PT Aven",
    },
    {
      id: 5,
      name: "",
      description: "",
    },
    {
      id: 6,
      name: "",
      description: "",
    },
  ];
  const centerIndex = Math.floor(userList.length / 2);

  return (
    <div>
      <div className=" text-center my-20">
        <h1 className="text-5xl font-semibold">
          Check what our clients are saying
        </h1>
        <p className="text-lg font-normal mt-5">
          Cum soluta nobis est eligendi optio cumque
        </p>
      </div>
      <div className="flex gap-10 justify-center items-center my-10">
        <Swiper
          spaceBetween={5}
          slidesPerView={1}
          navigation
          centeredSlides={true}
          // loop={true}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination, Navigation]}
          className=""
          onSwiper={setSwiperRef}
        >
          {userList.map((user, index) => (
            <SwiperSlide key={index}>
              <div className="w-[1270px] mx-auto ">
                <div
                  className={`flex p-2 rounded-md justify-center items-center gap-2 ${
                    index === centerIndex ? "shadow-md border" : ""
                  }`}
                >
                  <div className="">
                    <img
                      src={EmptyUserIcon}
                      alt="EmptyUserIcon"
                      className="h-20 w-20"
                    />
                  </div>
                  <div className="">
                    <h1 className="text-lg font-medium">{user.name}</h1>
                    <p className="font-normal">{user.description}</p>
                  </div>
                </div>
                <div className="p-16 flex flex-col justify-center items-center border shadow-md rounded-3xl">
                  <div className="flex">
                    <img src={StarIcon} alt="" className="h-6 w-6" />
                    <img src={StarIcon} alt="" className="h-6 w-6" />
                    <img src={StarIcon} alt="" className="h-6 w-6" />
                    <img src={StarIcon} alt="" className="h-6 w-6" />
                    <img src={StarIcon} alt="" className="h-6 w-6" />
                  </div>
                  <p className="max-w-lg text-center mx-auto my-8">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat
                  </p>
                  <div className="">
                    <img src={AvenIcon} alt="" className="h-28 w-28" />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonial;
